module.exports = "<div class=\"drzSection-divider\">\n  <img :src=\"_servePrefix(customImage) + customImage\" :alt=\"alt\" />\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/droplets/section/components/shape-dividers/custom/template.html
// module id = Ct/q
// module chunks = 0